import React from "react";
import Index from "./component";

function App() {
  return (
    <>
    <Index/>
    </>
  );
}

export default App;
